import { useMemo } from "react";
import { usePreloadPublicData, usePublicContentList } from "@lazylabs-dev/editry-react";
import { isEditryConfigured } from "../utils/editryConfig";

export function useGlobalSeo() {
  const editryReady = isEditryConfigured();
  usePreloadPublicData({ contentKeys: ['seo_seo_description', 'seo_seo_keywords'], auto: editryReady });
  const contentListResponse = usePublicContentList();

  const seo = useMemo(() => {
    const allContent = contentListResponse.data?.data || [];
    const descriptionRecord = allContent.find((item) => item.content_key === 'seo_seo_description');
    const keywordsRecord = allContent.find((item) => item.content_key === 'seo_seo_keywords');

    const description = typeof descriptionRecord?.value === 'string' ? descriptionRecord.value : '';
    const keywords = typeof keywordsRecord?.value === 'string' ? keywordsRecord.value : '';

    if (!description && !keywords) {
      return null;
    }

    return {
      data: {
        description,
        keywords,
      },
    };
  }, [contentListResponse.data]);

  return seo;
}
